import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import { TaskEnums, TaskEnumsLists } from "../../../../common/constants";
import { useMemo } from "react";
import moment from "moment/moment";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      position: "relative",
      display: "flex"
    },
    dotUnfilled: {
      height: "8px",
      width: "8px",
      background: theme.palette.neutral.main,
      borderRadius: "50%",
    },
    dotFilled: {
      height: "8px",
      width: "8px",
      background: theme.palette.primary.main,
      borderRadius: "50%",
    }
  })
);

export default function TaskProgressColumn(props) {
  const { task, station, value } = props;
  const { t } = useTranslation();
  const { classes } = useStyles();

  const { elements, timeSinceUpdate } = useMemo(() => {
    const hasTransport = !task?.resolvedAtLocation;
    const totalN = hasTransport ? (station?.includeArrivedDest ? 5 : 4) : 3;
    const progress = value - TaskEnums.State.Started;
    const stateTime = task.stateData?.lastModified || task.stateData?.created;
    return {
      elements: Array.from(Array(totalN)).map((_, idx) => idx <= progress),
      timeSinceUpdate: progress > 0 && !!stateTime ? `(${moment(stateTime).fromNow(true)})` : null
    };
  }, [task, station, value]);

  return (
    <Box className={classes.root}>
      <Stack direction="column" className={classes.root} justifyContent="center" alignItems="flex-start" spacing={1}>

        <Stack direction="row" spacing={0.25}>
          {elements.map((done, key) => <span className={done ? classes.dotFilled : classes.dotUnfilled} key={key}></span>)}
        </Stack>

        <Typography variant="body2" color="textSecondary">{t(`task:enums:state:${TaskEnumsLists.State[value]}`)} {timeSinceUpdate}</Typography>
      </Stack>
    </Box >
  );
}